<template>
  <v-card class="rounded-card"
          outlined>
    <v-card-subtitle>
      <span class="font-weight-bold">Empresas</span>
    </v-card-subtitle>
    <v-divider/>
    <v-list>
      <v-list-item v-for="(comprador, index) in compradores"
                   :key="comprador.id"
                   :input-value="isCompradorSelecionado(comprador)"
                   active-class="text-primary"
                   :class="`${lastItemClass(index)}`"
                   @click="onClickComprador(comprador)">
        <v-list-item-content :class="`pa-0`">
          <px-show-large-text :truncate-value="30"
                              :large-text="comprador.pessoa.nome"
                              :text-class="selectedItemClass(comprador)"/>
          <div :class="`caption ${selectedItemClass(comprador)}`">
            {{ comprador.pessoa.cnpj | cnpj }}
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    compradores: Array,
    idCompradorSelecionado: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isCompradorSelecionado() {
      return comprador => (comprador.id === this.idCompradorSelecionado);
    },
    selectedItemClass() {
      return comprador => (this.isCompradorSelecionado(comprador) ? 'font-weight-bold' : '');
    },
    lastItemClass() {
      return index => (index === this.compradores.length - 1 ? 'mb-1' : '');
    },
  },
  methods: {
    onClickComprador(comprador) {
      this.onChangeComprador(comprador);
    },
    onChangeComprador(comprador) {
      this.$emit('change', comprador);
    },
  },
};
</script>
